/**
 * Olanzu local wishlist — works without customer accounts.
 * Stores product handles in localStorage and syncs heart buttons + wishlist page.
 */
(function () {
  var KEY = 'olanzu_wishlist_v1';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('olanzu:wishlist-change', { detail: { list: list } }));
  }

  function normalize(item) {
    if (!item || !item.handle) return null;
    return {
      id: String(item.id || ''),
      handle: String(item.handle),
      title: item.title || '',
      url: item.url || '/products/' + item.handle,
      image: item.image || '',
      price: item.price || '',
      addedAt: item.addedAt || Date.now()
    };
  }

  function has(handle) {
    return read().some(function (item) {
      return item.handle === handle;
    });
  }

  function add(item) {
    var next = normalize(item);
    if (!next) return read();
    var list = read().filter(function (x) {
      return x.handle !== next.handle;
    });
    list.unshift(next);
    write(list);
    return list;
  }

  function remove(handle) {
    var list = read().filter(function (x) {
      return x.handle !== handle;
    });
    write(list);
    return list;
  }

  function toggle(item) {
    if (has(item.handle)) return remove(item.handle);
    return add(item);
  }

  function moneyFromCents(cents) {
    if (cents == null || cents === '') return '';
    var n = Number(cents) / 100;
    if (isNaN(n)) return String(cents);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function setButtonState(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active ? 'Remove from wishlist' : 'Add to wishlist';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
    var tip = btn.getAttribute('data-original-title');
    if (tip != null) btn.setAttribute('data-original-title', label);
  }

  function syncButtons(root) {
    var list = read();
    var handles = {};
    list.forEach(function (item) {
      handles[item.handle] = true;
    });
    (root || document)
      .querySelectorAll('[data-olanzu-wishlist]')
      .forEach(function (btn) {
        var handle = btn.getAttribute('data-handle');
        if (!handle) return;
        setButtonState(btn, !!handles[handle]);
      });

    var countEls = document.querySelectorAll('[data-olanzu-wishlist-count]');
    countEls.forEach(function (el) {
      el.textContent = String(list.length);
      el.hidden = list.length === 0;
    });
  }

  function bindButtons(root) {
    (root || document)
      .querySelectorAll('[data-olanzu-wishlist]')
      .forEach(function (btn) {
        if (btn.getAttribute('data-olanzu-bound') === '1') return;
        btn.setAttribute('data-olanzu-bound', '1');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var item = {
            id: btn.getAttribute('data-id'),
            handle: btn.getAttribute('data-handle'),
            title: btn.getAttribute('data-title'),
            url: btn.getAttribute('data-url'),
            image: btn.getAttribute('data-image'),
            price: btn.getAttribute('data-price')
          };
          if (!item.handle) return;
          toggle(item);
          syncButtons();
          btn.classList.add('olanzu-wishlist-pulse');
          setTimeout(function () {
            btn.classList.remove('olanzu-wishlist-pulse');
          }, 400);
        });
      });
  }

  function renderWishlistPage() {
    var mount = document.querySelector('[data-olanzu-wishlist-page]');
    if (!mount) return;

    var list = read();
    var empty = mount.querySelector('[data-olanzu-wishlist-empty]');
    var tableWrap = mount.querySelector('[data-olanzu-wishlist-table]');
    var body = mount.querySelector('[data-olanzu-wishlist-body]');
    if (!body) return;

    if (!list.length) {
      if (empty) empty.hidden = false;
      if (tableWrap) tableWrap.hidden = true;
      body.innerHTML = '';
      return;
    }

    if (empty) empty.hidden = true;
    if (tableWrap) tableWrap.hidden = false;

    body.innerHTML = list
      .map(function (item) {
        var price = item.price;
        if (price && String(price).match(/^\d+$/)) price = moneyFromCents(price);
        return (
          '<tr data-handle="' +
          item.handle +
          '">' +
          '<td class="prod_thumb"><a href="' +
          item.url +
          '"><img src="' +
          (item.image || '') +
          '" alt="" width="80" height="80" loading="lazy"></a></td>' +
          '<td class="prod_title"><a href="' +
          item.url +
          '">' +
          (item.title || item.handle) +
          '</a></td>' +
          '<td class="prod_price text-md-center">' +
          (price || '') +
          '</td>' +
          '<td class="prod_btn text-center"><a class="shop-button" href="' +
          item.url +
          '">View</a></td>' +
          '<td class="remove text-md-center"><button type="button" class="olanzu-wishlist-remove" data-remove-handle="' +
          item.handle +
          '" aria-label="Remove">×</button></td>' +
          '</tr>'
        );
      })
      .join('');

    body.querySelectorAll('[data-remove-handle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        remove(btn.getAttribute('data-remove-handle'));
        renderWishlistPage();
        syncButtons();
      });
    });
  }

  function init() {
    bindButtons(document);
    syncButtons(document);
    renderWishlistPage();
  }

  document.addEventListener('olanzu:wishlist-change', function () {
    syncButtons(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after theme AJAX / quickview content
  document.addEventListener('shopify:section:load', init);
  if (window.jQuery) {
    jQuery(document).on('ajaxComplete', function () {
      bindButtons(document);
      syncButtons(document);
    });
  }

  window.OlanzuWishlist = { read: read, add: add, remove: remove, toggle: toggle, has: has, sync: syncButtons };
})();
